import * as React from 'react'
import { Box, Button, CircularProgress, TextField } from '@mui/material'

import { SectionCard } from './SectionCard'
import type { WorkEntryCoordinatesModel } from '../../types/Work/WorkEntry'
import { getCurrentLocation } from '../../utils/LocationUtils'
import MyLocationIcon from '@mui/icons-material/MyLocation'

type Props = {
	value: WorkEntryCoordinatesModel
	onChange: (patch: Partial<WorkEntryCoordinatesModel>) => void
}

export function WorkEntryCoordinates({ value, onChange }: Props) {
	const [findingLocation, setFindingLocation] = React.useState(false)

	const handleFindLocation = async () => {
		setFindingLocation(true)
		const location = await getCurrentLocation()
		onChange({ latitude: location.latitude.toString(), longitude: location.longitude.toString() })
		setFindingLocation(false)
	}
	return (
		<SectionCard title='Coordinates'>
			<Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
				<TextField
					label='Latitude'
					size='small'
					value={value.latitude}
					onChange={(e) => onChange({ latitude: e.target.value })}
					sx={{ flex: 1 }}
				/>
				<TextField
					label='Longitude'
					size='small'
					value={value.longitude}
					onChange={(e) => onChange({ longitude: e.target.value })}
					sx={{ flex: 1 }}
				/>
				<Button
					variant='outlined'
					sx={{ minWidth: 140, color: 'text.primary', '&:hover': { color: 'text.primary' } }}
					onClick={handleFindLocation}
					disabled={findingLocation}
					startIcon={
						findingLocation ? (
							<CircularProgress size={20} sx={{ p: 0, m: 0 }} />
						) : (
							<MyLocationIcon />
						)
					}
				>
					Find My Location
				</Button>
			</Box>
		</SectionCard>
	)
}
